// extracted by mini-css-extract-plugin
export default {"component":"button__h7OFO"};